import React from 'react'
import { TIconColor } from 'transfix-ui/components/SvgIcon/types'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import makeStyles from 'transfix-ui/core/styles/makeStyles'
import { DryVanIcon, ReeferIcon, FlatBedIcon } from 'transfix-icons'
import {
  PriceRequestEquipment,
  REEFER_53_ID,
  REEFER_ID,
  VAN_53_ID,
  DRY_VAN_ID,
  FLATBED_48_ID,
  FLATBED_53_ID,
} from '../constants/equipment'

interface IEquipmentIconCellProps {
  equipmentId?: number | null
  showLabel?: boolean
}

const useStyles = makeStyles(() => ({
  icon: {
    marginTop: '5px',
    marginLeft: '3px',
  },
  iconParent: {
    display: 'flex',
    alignItems: 'center',
  },
}))

export function EquipmentIconCell({ equipmentId, showLabel = false }: IEquipmentIconCellProps) {
  const color: TIconColor = showLabel ? 'black' : 'coolGray5'
  const classes = useStyles()

  const equipmentMap: Record<number, { icon: JSX.Element; label: PriceRequestEquipment }> = {
    [REEFER_53_ID]: {
      icon: <ReeferIcon size='large' color={color} />,
      label: PriceRequestEquipment.reefer53,
    },
    [VAN_53_ID]: {
      icon: <DryVanIcon size='large' color={color} />,
      label: PriceRequestEquipment.van53,
    },
    [REEFER_ID]: {
      icon: <ReeferIcon size='large' color={color} />,
      label: PriceRequestEquipment.reefer,
    },
    [DRY_VAN_ID]: {
      icon: <DryVanIcon size='large' color={color} />,
      label: PriceRequestEquipment.dryVan,
    },
    [FLATBED_53_ID]: {
      icon: <FlatBedIcon size='large' color={color} />,
      label: PriceRequestEquipment.flatbed53,
    },
    [FLATBED_48_ID]: {
      icon: <FlatBedIcon size='large' color={color} />,
      label: PriceRequestEquipment.flatbed48,
    },
  }

  if (equipmentId && equipmentMap[equipmentId]) {
    const { icon, label } = equipmentMap[equipmentId]

    return (
      <div className={classes.iconParent}>
        <Tooltip trigger={<span className={classes.icon}>{icon}</span>}>{label}</Tooltip>
        &nbsp; {showLabel && label}
      </div>
    )
  }

  // Default case
  return <DryVanIcon size='large' />
}
